import { render, staticRenderFns } from "./delivery-addresses-crud.vue?vue&type=template&id=e7b29d0a&"
import script from "./delivery-addresses-crud.vue?vue&type=script&lang=js&"
export * from "./delivery-addresses-crud.vue?vue&type=script&lang=js&"
import style0 from "./delivery-addresses-crud.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports